import React, { Component } from 'react';
import { Page, Layout, Card, FormLayout, TextField, RangeSlider, Banner, SettingToggle, Text, Checkbox, ButtonGroup, Button, LegacyStack, Select, PageActions } from '@shopify/polaris';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ColorPickerCustom } from './ColorPickerCustom';
import { DesktopMajor, MobileMajor } from '@shopify/polaris-icons';
import { fetchApi } from './helpers/fetchApi';

var btnAnimation = "";

export class StickyCheckoutBar extends Component {

    constructor(props) {
        super(props);
        props.setIsLoading(true);

        this.saveChanges = this.saveChanges.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.discardChanges = this.discardChanges.bind(this);
        this.togglePreviewActive = this.togglePreviewActive.bind(this);

        this.state = { initState: {}, model: {}, loading: true, previewActive: true, previewDesktop: true };
    }
   
    componentDidMount() {
        this.populateData();
        this.props.setSaveChanges(this.saveChanges);
        this.props.setDiscardChanges(this.discardChanges);
    }

    discardChanges(){
        this.setState({ model: Object.assign({}, this.state.initState) ,initState: Object.assign({}, this.state.initState) });
    }

    handleChange(fieldName, newValue) {
        window?.shopify?.saveBar?.show("satcb-save-bar");

        this.setState(prevState => {
            let model = Object.assign({}, prevState.model);
            model[fieldName] = newValue;
            const isDirty = JSON.stringify(this.state.initState) !== JSON.stringify(model);
            this.props.setIsDirty(isDirty);
            if(!isDirty){
                window?.shopify?.saveBar?.hide("satcb-save-bar");
            }
            return { model };
        });

        if (fieldName === 'buttonAnimation') {
            btnAnimation = newValue;
            window.$('.satcb_checkout_btn:visible').satcb_animateCss(btnAnimation);
        }
    }

    handlePreview(previewDesktop) {
        this.setState({ previewDesktop: previewDesktop });
        var topNavTimer = setInterval(function(){
            if(window.$('#preview').length > 0){
                setTimeout(function () { window.$('#preview').sticky('update'); }, 0);
            }
        },500);
    }

    togglePreviewActive() {
        this.setState({ previewActive: !this.state.previewActive });
        var topNavTimer = setInterval(function(){
            if(window.$('#preview').length > 0){
                setTimeout(function () { window.$('#preview').sticky('update'); }, 0);
                
            }
        },500);    }

    render() {

        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page title="Sticky checkout bar">
                    <Layout>
                        <Layout.Section>
                            {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed <= 0 && (
                                <Banner
                                    title={`Free plan usage Limit Reached: App Paused Until ${(new Date(this.props.common.freePlanCreditsResetDate)).toLocaleString(undefined, {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}`}
                                    status="critical"
                                    action={{
                                        content: 'Upgrade now', onAction: () => {
                                            const params = new URLSearchParams(this.state.url);
                                            const shop = params.get("shop");
                                            const host = params.get("host");
                                            window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                        }
                                    }}
                                >
                                    <p>
                                        Your store is currently on the Free plan whose limit is reached and the STKTY app is paused until your next 30-day cycle. Upgrade your plan now to avoid disruptions.
                                    </p>
                                </Banner>
                            )}
                            {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed > 0 && (
                                <Banner
                                    title={`Free plan usage: ${this.props.common.freePlanClicksUsed >= 0 ? this.props.common.freePlanClicksUsed : 0} clicks left out of 25`}
                                    status="warning"
                                    action={{
                                        content: 'View plans', onAction: () => {
                                            const params = new URLSearchParams(this.state.url);
                                            const shop = params.get("shop");
                                            const host = params.get("host");
                                            window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                        }
                                    }}
                                >
                                    <p>
                                        Your store is currently on the Free plan. Once 25 clicks are reached, all STKY widgets will be paused until your next 30-day cycle. Upgrade your plan today to avoid disruptions.
                                    </p>
                                </Banner>
                            )}
                        </Layout.Section>
                        <Layout.Section>
                            <Banner
                                title="What is Sticky checkout bar/button?"
                                status="info"
                            >
                                <p>Sticky checkout bar/button will show on Cart page when user starts scrolling down. It will show number of items in the cart, total price and Checkout button. Its main goal is to improve user's experience and make checkout easier. On desktop devices it will show as a bar with a button. On mobile devices it will show as a full width button. Note that if cart is empty Sticky checkout bar/button will not show.</p>
                            </Banner>
                        </Layout.Section>
                        <Layout.Section>
                            <div id="preview" className={(this.state.previewDesktop ? 'desktop' : 'mobile') + (this.state.previewActive ? '' : ' preview-hidden')}>
                                <Card title="Preview" sectioned actions={[{ content: this.state.previewActive ? 'Collapse ↑' : 'Expand ↓', onAction: this.togglePreviewActive }]}>
                                    <Card.Section>
                                        <div id="satcb_checkout_bar" style={{
                                            backgroundColor: this.state.model.barBackgroundColor ? this.state.model.barBackgroundColor : '#fff',
                                            fontFamily: this.state.model.fontFace,
                                            color: this.state.model.barTextColor ? this.state.model.barTextColor : '#3d4246',
                                            display: this.state.previewDesktop && this.state.previewActive ? 'block' : 'none'
                                        }}>
                                            <div className="satcb_checkout_items-holder" style={{ display: this.state.model.showTotalItemsDesktop ? 'inline-block' : 'none' }}>
                                                <span className="satcb_checkout_items" style={{ fontSize: this.state.model.priceItemFontSize+'px'}}>2 {this.state.model.ItemsText ? this.state.model.ItemsText : 'ITEMS'}</span>
                                            </div>
                                            <div className="satcb_checkout_btn-holder">
                                                <button style={{
                                                    color: this.state.model.buttonTextColor ? this.state.model.buttonTextColor : '#fff',
                                                    fontSize: this.state.model.buttonFontSize + 'px',
                                                    fontFamily: this.state.model.fontFace,
                                                    backgroundColor: this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8',
                                                    borderColor: this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8',
                                                }}
                                                    data-color={this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8'} data-text-color={this.state.model.buttonTextColor ? this.state.model.buttonTextColor : '#fff'}
                                                    data-hover-color={this.state.model.buttonHoverColor ? this.state.model.buttonHoverColor : '#7796a8'} data-hover-text-color={this.state.model.buttonTextHoverColor ? this.state.model.buttonTextHoverColor : '#fff'}
                                                    type="submit" name="add" className="satcb_checkout_btn">{this.state.model.buttonText ? this.state.model.buttonText : 'Check out'}
                                                </button>
                                            </div>
                                            <div className="satcb_checkout_price-holder" style={{ display: this.state.model.showTotalPriceDesktop ? 'block' : 'none' }}>
                                                <span className="satcb_checkout_price" style={{ color: '#e44e4e', fontWeight: 'bold', fontSize: this.state.model.priceItemFontSize + 'px' }}>$129.00</span>
                                            </div>
                                            <div className="satcb_was_price" style={{
                                                marginTop: '13px',
                                                color: this.state.model.comparePriceColor ? this.state.model.comparePriceColor : '#999',
                                                display: this.state.model.showComparePriceDesktop ? 'flex' : 'none'
                                            }}>
                                                $159.00
                                            </div>
                                        </div>
                                        <button className="satcb_checkout_btn satcb_checkout_btn_mobile" style={{
                                            color: this.state.model.buttonTextColor ? this.state.model.buttonTextColor : '#fff',
                                            backgroundColor: this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8',
                                            borderColor: this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8',
                                            display: this.state.previewDesktop || !this.state.previewActive ? 'none' : 'block'
                                        }}
                                            data-color={this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8'} data-text-color={this.state.model.buttonTextColor ? this.state.model.buttonTextColor : '#fff'}
                                            data-hover-color={this.state.model.buttonHoverColor ? this.state.model.buttonHoverColor : '#7796a8'} data-hover-text-color={this.state.model.buttonTextHoverColor ? this.state.model.buttonTextHoverColor : '#fff'}
                                        >
                                            <span className="satcb_checkout_items" style={{ display: this.state.model.showTotalItemsMobile ? 'block' : 'none' }}>2 {this.state.model.ItemsText ? this.state.model.ItemsText : 'ITEMS'}</span>
                                            {this.state.model.buttonText ? this.state.model.buttonText : 'Check out'}
                                            <span className="satcb_checkout_price" style={{
                                                textDecorationLine: 'line-through',
                                                position: 'absolute',
                                                right: '56px',
                                                top: 0,
                                                color: this.state.model.comparePriceColor ? this.state.model.comparePriceColor : '#fff',
                                                display: this.state.model.showComparePriceMobile ? 'flex' : 'none'
                                            }}>
                                                $159.00
                                            </span>
                                            <span className="satcb_checkout_price" style={{ color: '#e44e4e', display: this.state.model.showTotalPriceMobile ? 'block' : 'none' }}>$129.00</span>
                                        </button>
                                    </Card.Section>
                                    <LegacyStack alignment="center" distribution="center">
                                        <div style={{ display: this.state.previewActive ? 'block' : 'none' }}>
                                            <ButtonGroup segmented con>
                                                <Button pressed={this.state.previewDesktop} onClick={(newValue) => this.handlePreview(true)} icon={DesktopMajor}>Desktop preview</Button>
                                                <Button pressed={!this.state.previewDesktop} onClick={(newValue) => this.handlePreview(false)} icon={MobileMajor}>Mobile preview</Button>
                                            </ButtonGroup>
                                        </div>
                                    </LegacyStack>
                                </Card>
                            </div>
                        </Layout.Section>
                        <Layout.AnnotatedSection
                            title="Sticky checkout bar state"
                        >
                            <SettingToggle action={{
                                content: this.state.model.enabled ? 'Disable' : 'Enable',
                                onAction: () => { this.handleChange('enabled', !this.state.model.enabled) }
                            }}
                                enabled={this.state.model.enabled}
                            >
                                Sticky checkout bar is currently <Text as="span" fontWeight="semibold">{this.state.model.enabled ? 'enabled' : 'disabled'}</Text>.
                            </SettingToggle>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="General settings"
                            description=""
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <Select
                                        label="Button animation"
                                        helpText="Repeats every 5 seconds"
                                        options={[{ label: 'None', value: 'none' }, { label: 'Bounce', value: 'bounce' }, { label: 'Flash', value: 'flash' }, { label: 'Pulse', value: 'pulse' }, { label: 'Rubber band', value: 'rubberBand' }, { label: 'Shake', value: 'shake' }, { label: 'Swing', value: 'swing' }, { label: 'Tada', value: 'tada' }, { label: 'Wobble', value: 'wobble' }, { label: 'Jello', value: 'jello' }]}
                                        onChange={(newValue) => this.handleChange('buttonAnimation', newValue)}
                                        value={this.state.model.buttonAnimation}
                                    />
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Look and feel"
                            description="App will automatically match your site's branding but you can also adjust it's Look and feel to your liking here."
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <TextField
                                        value={this.state.model.buttonText}
                                        onChange={(newValue) => this.handleChange('buttonText', newValue)}
                                        label="Override button text"
                                    />
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.ItemText}
                                            onChange={(newValue) => this.handleChange('ItemText', newValue)}
                                            label='Translate "Item" text (singular)'
                                        />
                                        <TextField
                                            value={this.state.model.ItemsText}
                                            onChange={(newValue) => this.handleChange('ItemsText', newValue)}
                                            label='Translate "Items" text (plural)'
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <ColorPickerCustom
                                            label="Override button color"
                                            fieldName="buttonColor"
                                            value={this.state.model.buttonColor}
                                            handleChange={this.handleChange}
                                        />
                                        <ColorPickerCustom
                                            label="Override button hover color"
                                            fieldName="buttonHoverColor"
                                            value={this.state.model.buttonHoverColor}
                                            handleChange={this.handleChange}
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <ColorPickerCustom
                                            label="Override Button text color"
                                            fieldName="buttonTextColor"
                                            value={this.state.model.buttonTextColor}
                                            handleChange={this.handleChange}
                                        />
                                        <ColorPickerCustom
                                            label="Override button text hover color"
                                            fieldName="buttonTextHoverColor"
                                            value={this.state.model.buttonTextHoverColor}
                                            handleChange={this.handleChange}
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <ColorPickerCustom
                                            label="Override bar background color"
                                            fieldName="barBackgroundColor"
                                            value={this.state.model.barBackgroundColor}
                                            handleChange={this.handleChange}
                                        />
                                        <ColorPickerCustom
                                            label="Override bar text color"
                                            fieldName="barTextColor"
                                            value={this.state.model.barTextColor}
                                            handleChange={this.handleChange}
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <RangeSlider
                                        output
                                        label="Override button font size"
                                        min={12}
                                        step={2}
                                        max={36}
                                        onChange={(newValue) => this.handleChange('buttonFontSize',JSON.stringify(newValue))}
                                        value={this.state.model.buttonFontSize}
                                        />
                                        <RangeSlider
                                            output
                                            label="Override price and items font size"
                                            min={12}
                                            max={36}
                                            step={2}
                                            onChange={(newValue) => this.handleChange('priceItemFontSize',JSON.stringify(newValue))}
                                            value={this.state.model.priceItemFontSize}
                                        />    
                                        <Select
                                            label="Override font face"
                                            options={[{ label: 'Default', value: "" },{ label: 'Roboto', value: 'Roboto' }, { label: 'Playfair Display', value: 'Playfair Display' }, { label: 'Open Sans', value: 'Open Sans' }, { label: 'Oswald', value: 'Oswald' }, { label: 'Cabin', value: 'Cabin' }, { label: 'Montserrat', value: 'Montserrat' }, { label: 'Merriweather', value: 'Merriweather' }, { label: 'Cormorant', value: 'Cormorant' }, { label: 'Poppins', value: 'Poppins' }, { label: 'Nunito', value: 'Nunito' }, {label:'Lato',value:'Lato'}]}
                                            onChange={(newValue) => this.handleChange('fontFace', newValue)}
                                            value={this.state.model.fontFace}
                                        />
                                    </FormLayout.Group>
                                    
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Desktop settings"
                            description=""
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <Checkbox
                                        label="Show on desktop computers"
                                        checked={this.state.model.showOnDesktop}
                                        onChange={(newValue) => this.handleChange('showOnDesktop', newValue)}
                                    />
                                    <Checkbox
                                        label="Show total price"
                                        checked={this.state.model.showTotalPriceDesktop}
                                        onChange={(newValue) => this.handleChange('showTotalPriceDesktop', newValue)}
                                    />
                                    <Checkbox
                                        label="Show total items"
                                        checked={this.state.model.showTotalItemsDesktop}
                                        onChange={(newValue) => this.handleChange('showTotalItemsDesktop', newValue)}
                                    />
                                    <Checkbox
                                        label="Show compare price"
                                        checked={this.state.model.showComparePriceDesktop}
                                        onChange={(newValue) => this.handleChange('showComparePriceDesktop', newValue)}
                                    />
                                    <p>Bar position</p>
                                    <ButtonGroup segmented con>
                                        <Button pressed={this.state.model.barPositionDesktop === 'top'} onClick={(newValue) => this.handleChange('barPositionDesktop', 'top')}>
                                            Top
                                        </Button>
                                        <Button pressed={this.state.model.barPositionDesktop === 'bottom'} onClick={(newValue) => this.handleChange('barPositionDesktop', 'bottom')}>
                                            Bottom
                                        </Button>
                                    </ButtonGroup>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Mobile settings"
                            description=""
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <Checkbox
                                        label="Show on tablets and mobile devices"
                                        checked={this.state.model.showOnMobile}
                                        onChange={(newValue) => this.handleChange('showOnMobile', newValue)}
                                    />
                                    <Checkbox
                                        label="Show total price"
                                        checked={this.state.model.showTotalPriceMobile}
                                        onChange={(newValue) => this.handleChange('showTotalPriceMobile', newValue)}
                                    />
                                    <Checkbox
                                        label="Show total items"
                                        checked={this.state.model.showTotalItemsMobile}
                                        onChange={(newValue) => this.handleChange('showTotalItemsMobile', newValue)}
                                    />
                                    <Checkbox
                                        label="Show compare price"
                                        checked={this.state.model.showComparePriceMobile}
                                        onChange={(newValue) => this.handleChange('showComparePriceMobile', newValue)}
                                    />
                                    <p>Bar position</p>
                                    <ButtonGroup segmented con>
                                        <Button pressed={this.state.model.barPositionMobile === 'top'} onClick={(newValue) => this.handleChange('barPositionMobile', 'top')}>
                                            Top
                                        </Button>
                                        <Button pressed={this.state.model.barPositionMobile === 'bottom'} onClick={(newValue) => this.handleChange('barPositionMobile', 'bottom')}>
                                            Bottom
                                        </Button>
                                    </ButtonGroup>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.Section>
                            {window.innerWidth < 768 ? 
                            <LegacyStack alignment="center" distribution="center">
                                <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />
                            </LegacyStack> 
                            : 
                                <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />
                            }
                        </Layout.Section>
                    </Layout>
                </Page >
        );
    }

    async populateData() {
        const response = await fetchApi('api/home/stickyCheckoutBar');
        const data = await response.json();

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            this.props.setIsLoading(false);
            this.setState({ initState: data, model: data, loading: false });

            var topNavTimer = setInterval(function(){
                if(window.$('#preview').length > 0){
                    window.$('#preview').sticky({ topSpacing: 0, zIndex: 100 });
                    
                }
            },500);
            
            window.$('.satcb_checkout_btn').hover(
                function () {
                    window.$(this).css('background-color', window.$(this).attr('data-hover-color'));
                    window.$(this).css('border-color', window.$(this).attr('data-hover-color'));
                    window.$(this).css('color', window.$(this).attr('data-hover-text-color'));
                },
                function () {
                    window.$(this).css('background-color', window.$(this).attr('data-color'));
                    window.$(this).css('border-color', window.$(this).attr('data-color'));
                    window.$(this).css('color', window.$(this).attr('data-text-color'));
                });

            btnAnimation = data.buttonAnimation;
            setInterval(function () {
                if (window.$('.satcb_checkout_btn:hover').length === 0 && window.$('.satcb_checkout_btn:visible').length > 0 && btnAnimation !== 'None') {
                    window.$('.satcb_checkout_btn:visible').satcb_animateCss(btnAnimation);
                }
            }, 5000);
        }
    }

    async saveChanges() {
        this.props.setIsLoading(true);
        const response = await fetchApi('api/home/saveStickyCheckoutBar', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.model) });
        const data = await response.json();
        this.props.setIsLoading(false);

        if (response.ok === true) {
            window?.shopify?.saveBar?.hide("satcb-save-bar");

            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.setState({ initState: Object.assign({}, this.state.model) });
                this.props.setIsDirty(false);
                this.props.setToastActive(true);
            }
        }
    }
}